/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreSiteName = process.env.SITECORE_SITE_NAME || 'upmchealthplan';
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || 'en';
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || 'https://hpwsp-eus2-app-cd-prd.azurewebsites.net/sitecore/api/graph/edge';
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || '/sitecore/api/graph/edge';
config.sitecoreApiHost = process.env.SITECORE_API_HOST || 'https://hpwsp-eus2-app-cd-prd.azurewebsites.net';
config.sitecoreApiKey = process.env.SITECORE_API_KEY || '6FD03845-4AB4-47CE-9349-2B6FE898D68A';
config.layoutServiceConfigurationName = process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || 'sxa-jss';
config.sites = process.env.SITES || '[]';
config.publicUrl = process.env.PUBLIC_URL || 'https://www.upmchealthplan.com';
module.exports = config;